<template>
  <div class="fb-comments" :data-href="'https://www.weddingsung.com/songs/'+videoId" data-width="800" data-numposts="5"></div>
</template>

<script>
/* eslint-disable */
export default {
  props: ['videoId'],
  name: 'fbcomment',
  data () {
    return {
      msg: 'Footer'
    }
  },
  mounted: function () {
    console.log(this.videoId)
  }
}
</script>



// WEBPACK FOOTER //
// Fbcomment.vue?7d64279c